import $ from 'jquery';
import Svg_Icons from 'root/module/svg_icon';
import Tooltip from 'root/module/tooltip';
import Modal from 'root/module/modal';

export default {
    device_list: {
        audioinput:  [],
        videoinput:  [],
        audiooutput: [],
        videooutput: []
    },

    recorded_blobs  : [],
    recorder        : null,

    audio_script_processor: null,

    screen_stream   : null,
    voice_stream    : null,
    combined_stream : null,

    options: {
        onSubmit: null,
        onCancel: null
    },

    timer_timeout: null, // 2 min timer
    timer: 180, // 180 seconds

    count_down_timeout: null, // 3 second count down
    count_down: 3, // 3 seconds

    is_muted: false,

    isOpen: function() {
        return this.controls ? true : false;
    },

    start: function(options) {
        this.options.onSubmit = options.onSubmit || null;
        this.options.onCancel = options.onCancel || null;

        this.reset();
        this.getDevice(this.createControls.bind(this));
    },

    reset: function() {
        this.recorded_blobs  = [];
        this.recorder        = null;

        this.audio_script_processor = null;

        this.screen_stream   = null;
        this.voice_stream    = null;
        this.combined_stream = null;

        this.is_muted = false;

        this.timer = 180;

        if (this.controls) {
            this.pause_btn.html(Svg_Icons.pause);
        }
    },

    getDevice: function(callback) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            callback();
            return;
        }

        navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                devices.forEach(function(device) {
                    switch (device.kind) {
                        case 'audioinput':
                            this.device_list.audioinput.push(device);
                            break;
                        case 'videoinput':
                            this.device_list.videoinput.push(device);
                            break;
                        case 'audiooutput':
                            this.device_list.audiooutput.push(device);
                            break;
                        case 'videooutput':
                            this.device_list.videooutput.push(device);
                            break;
                    }
                }.bind(this));

                callback();
            }.bind(this))
            .catch(function(error) {
            });
    },

    createControls: function() {
        this.controls = $('<div>')
            .attr('class', 'video-capture-controls')
            .appendTo($(document.body));

        this.mute_btn    = $('<button>')
                            .addClass('userback-video-controls-mute userback-video-controls-active tooltip')
                            .attr('data-title', 'Turn off microphone')
                            .html(Svg_Icons.media_mic + '<span>Mute</span>')
                            .appendTo(this.controls);

        this.pause_btn   = $('<button>')
                            .addClass('userback-video-controls-pause tooltip')
                            .attr('data-title', 'Pause')
                            .html(Svg_Icons.media_pause + '<span>Pause</span>')
                            .appendTo(this.controls)
                            .prop('disabled', true);

        this.stop_btn    = $('<button>')
                            .addClass('userback-video-controls-stop tooltip')
                            .attr('data-title', 'Finish recording')
                            .html(Svg_Icons.media_stop + '<span>Finish</span>')
                            .appendTo(this.controls);

        this.record_btn  = $('<button>')
                            .addClass('userback-video-controls-recording')
                            .text('03:00')
                            .appendTo(this.controls);

        this.mic_volume = $('<div>')
                            .html('<span></span><span></span>' +
                                    '<span></span><span></span>' +
                                    '<span></span><span></span>' +
                                    '<span></span><span></span>' +
                                    '<span></span><span></span>')
                            .addClass('userback-mic-volume')
                            .appendTo(this.mute_btn);

        if (!this.device_list.audioinput.length) {
            this.is_muted = true;
            this.mute_btn.removeClass('userback-video-controls-active').prop('disabled', true);
        }

        this.stop_btn.on('click',  this.stopCapture.bind(this));
        this.pause_btn.on('click', this.pauseRecording.bind(this));
        this.mute_btn.on('click',  this.muteVoice.bind(this));

        this.startCapture();
    },

    removeControls: function() {
        this.controls.remove();
        this.controls = null;

        // remove mic analyser
        if (this.audio_script_processor && typeof this.audio_script_processor._disconnect !== 'undefined') {
            this.audio_script_processor._disconnect();
        }

        Tooltip.removeAll();
    },

    muteVoice: function() {
        if (this.mute_btn.attr('disabled')) {
            return;
        }

        this.is_muted = !this.is_muted;

        if (this.is_muted) {
            this.mute_btn.removeClass('userback-video-controls-active');
            this.mute_btn.children('btn-tooltip').text('Turn on microphone');
        } else {
            this.mute_btn.addClass('userback-video-controls-active');
            this.mute_btn.children('btn-tooltip').text('Turn off microphone');
        }

        this.toggleAudio();
    },

    toggleAudio: function() {
        if (!this.combined_stream) {
            return;
        }

        var audio_tracks = this.combined_stream.getAudioTracks();
        if (audio_tracks.length) {
            audio_tracks.forEach(function(audio_track) {
                audio_track.enabled = !this.is_muted;
            }.bind(this));
        }
    },

    startCapture: function() {
        var displayMediaOptions = {
            video: {
                cursor: 'always'
            },
            audio: false
        };

        var userMediaOptions = {
            audio: true,
            video: false
        };

        try {
            var _warnBrowser = function(e) {
                if (typeof e.name !== 'undefined' && e.name === 'NotAllowedError') {
                    this.stopCapture();
                } else {
                    Modal.open({
                        title: 'Browser not supported',
                        content: '<p><b>Video recording is not supported in your browser</b><br>Please download the latest version of <a href="https://www.google.com/chrome/">Chrome</a>, <a href="https://www.mozilla.org/firefox/download/thanks/">Firefox</a> or <a href="http://microsoft.com/en-us/edge">Microsoft Edge</a>.</p>',
                        onclose: function() {
                            this.stopCapture();
                        }.bind(this)
                    });
                }
            }.bind(this);

            var _afterGetVideoStream = function() {
                // when clicking the stop share button
                this.screen_stream.getTracks()[0].onended = function() {
                    this.stopCapture();
                }.bind(this);

                var count_down = this.count_down;

                var _timer = function() {
                    if (count_down === 0) {
                        this.record_btn.show();

                        $('.video-count-down').remove();

                        this.startRecording();
                    } else {
                        $('<div>').addClass('video-count-down').text(count_down).appendTo($(document.body));

                        count_down--;

                        this.count_down_timeout = setTimeout(_timer.bind(this), 1000);
                    }
                };

                _timer.call(this);
            }.bind(this);

            var _afterGetVoiceStream = function() {
                if (this.voice_stream) {
                    navigator.mediaDevices.getDisplayMedia(displayMediaOptions)
                        .then(function(stream) {
                            this.screen_stream = stream;

                            var screen_tracks = this.screen_stream.getTracks();
                            var voice_tracks  = this.voice_stream.getTracks();

                            this.combined_stream = new MediaStream(screen_tracks.concat(voice_tracks));

                            _afterGetVideoStream();
                        }.bind(this))
                        .catch(function(e) {
                            _warnBrowser(e);
                        });
                } else {
                    navigator.mediaDevices.getDisplayMedia(displayMediaOptions)
                        .then(function(stream) {
                            this.screen_stream = stream;

                            var screen_tracks = this.screen_stream.getTracks();
                            this.combined_stream = this.screen_stream;

                            // disabled mic button
                            this.is_muted = true;
                            this.mute_btn.removeClass('userback-video-controls-active').prop('disabled', true);

                            _afterGetVideoStream();
                        }.bind(this))
                        .catch(function(e) {
                            _warnBrowser(e);
                        });
                }
            }.bind(this);

            if (this.device_list.audioinput.length) {
                navigator.mediaDevices.getUserMedia(userMediaOptions)
                    .then(function(stream) {
                        this.voice_stream = stream;

                        _afterGetVoiceStream();

                        try {
                            var audio_context           = new AudioContext();
                            var analyser                = audio_context.createAnalyser();
                            var microphone              = audio_context.createMediaStreamSource(stream);
                            this.audio_script_processor = audio_context.createScriptProcessor(2048, 1, 1);

                            analyser.smoothingTimeConstant = 0.8;
                            analyser.fftSize = 1024;

                            microphone.connect(analyser);
                            analyser.connect(this.audio_script_processor);
                            this.audio_script_processor.connect(audio_context.destination);

                            this.audio_script_processor._disconnect = function() {
                                this.audio_script_processor.disconnect(audio_context.destination);
                            }.bind(this);

                            this.audio_script_processor.onaudioprocess = function() {
                                var values = 0;
                                var array = new Uint8Array(analyser.frequencyBinCount);
                                analyser.getByteFrequencyData(array);

                                for (var i = 0; i < array.length; i++) {
                                    values += (array[i]);
                                }

                                var average = values / array.length;
                                var volume  = Math.floor(average / 150 * 10); // max 150

                                this.mic_volume.find('span').each(function(index) {
                                    $(this).toggle(index < volume);
                                });
                            }.bind(this);
                        } catch (e) {
                            // api is not supported: ignore
                        }
                    }.bind(this))
                    .catch(function() {
                        // cant get microphone: DOMException: Permission denied
                        _afterGetVoiceStream();
                    }.bind(this));
            } else {
                _afterGetVoiceStream();
            }
        } catch (e) {
            _warnBrowser(e);
        }
    },

    stopCapture: function() {
        if (this.recorder) {
            this.submitRecording();
        } else {
            this.stopRecording();

            if (this.options.onCancel) {
                this.options.onCancel();
            }

            this.removeControls();
            this.reset();
        }
    },

    startTimer: function() {
        this.timer_timeout = setInterval(function() {
            var min = Math.floor(this.timer / 60);
            var sec = this.timer - min * 60;

            if (min === 0 && sec === 0) {
                clearInterval(this.timer_timeout);

                this.submitRecording();
            }

            if (min < 10) {
                min = '0' + min;
            }

            if (sec < 10) {
                sec = '0' + sec;
            }

            this.record_btn.text(min + ':' + sec);

            this.timer--;
        }.bind(this), 1000);
    },

    stopTimer: function() {
        clearInterval(this.timer_timeout);
    },

    stopCountDown: function() {
        clearTimeout(this.count_down_timeout);
    },

    startRecording: function() {
        try {
            // vp8 and opus are supported by Chrome and Firefox
            this.recorder = new MediaRecorder(this.combined_stream, {
                mimeType: 'video/webm; codecs="vp8, opus"'
            });
        } catch (e) {
            return;
        }

        this.toggleAudio();

        this.recorder.addEventListener('dataavailable', this.handleDataAvailable.bind(this));
        this.recorder.start(10); // collect 10ms of data in each blob

        this.pause_btn.prop('disabled', false);

        this.startTimer();

        window.addEventListener('beforeunload', function(e) {
            if (!this.recorder) {
                return;
            }

            // Cancel the event
            e.preventDefault();

            // If you prevent default behavior in Mozilla Firefox prompt will always be shown
            // Chrome requires returnValue to be set
            e.returnValue = '';
        }.bind(this));
    },

    stopRecording: function() {
        if (this.recorder) {
            this.recorder.stop();
        }

        if (this.combined_stream) {
            this.combined_stream.getTracks().forEach(function(track) {
                track.stop();
            });
        }

        this.stopTimer();
        this.stopCountDown();
    },

    pauseRecording: function() {
        if (!this.recorder) {
            return;
        }

        switch (this.recorder.state) {
            case 'recording':
                this.pause_btn.html(Svg_Icons.media_replay + '<span>Resume</span>');

                this.recorder.pause();

                this.stopTimer();
                break;
            case 'paused':
                this.pause_btn.html(Svg_Icons.media_pause + '<span>Pause</span>');
                this.recorder.resume();

                this.startTimer();
                break;
        }
    },

    submitRecording: function() {
        this.stopRecording();

        if (this.options.onSubmit) {
            var video_blob = new Blob(this.recorded_blobs, {type: 'video/webm'});

            this.options.onSubmit(video_blob);
        }

        this.removeControls();
        this.reset();
    },

    handleDataAvailable: function(e) {
        if (e.data && e.data.size > 0) {
            this.recorded_blobs.push(e.data);
        }
    }
};